import { useEffect, useState } from "react";
import API from "../../api/api";
import Toast from "../../components/Toast";

function DonationList() {
    const [list, setList] = useState([]);
    const [filteredList, setFilteredList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [toast, setToast] = useState(null);

    const fetchDonations = () => {
        setLoading(true);
        console.log("Fetching donations from /donation...");
        API.get("/donation")
            .then(res => {
                console.log("Donations received:", res.data);
                setList(res.data);
                setFilteredList(res.data);
            })
            .catch(err => {
                console.error("Error fetching donations:", err);
                console.error("Error details:", err.response?.data || err.message);
                setList([]);
            })
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        fetchDonations();
    }, []);

    useEffect(() => {
        const results = list.filter(x =>
            x.Name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            x.Email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            x.Mobile?.includes(searchTerm)
        );
        setFilteredList(results);
    }, [searchTerm, list]);

    const showToast = (message, type = "success") => {
        setToast({ message, type });
    };

    const handleDelete = (id) => {
        if (window.confirm("Are you sure you want to delete this donation?")) {
            API.delete(`/donation/${id}`)
                .then(() => {
                    showToast("Donation deleted successfully");
                    fetchDonations();
                })
                .catch(err => {
                    console.error("Error deleting donation:", err);
                    showToast("Failed to delete donation", "error");
                });
        }
    };

    return (
        <div className="admin-card">
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px", flexWrap: "wrap", gap: "10px" }}>
                <h2 style={{ margin: 0 }}>Donations</h2>
                <input
                    className="form-control"
                    placeholder="Search donations..."
                    style={{ width: "300px", borderRadius: "20px" }}
                    value={searchTerm}
                    onChange={e => setSearchTerm(e.target.value)}
                />
            </div>

            {loading ? (
                <p>Loading donations...</p>
            ) : (
                <div style={{ overflowX: "auto" }}>
                    <table className="admin-table">
                        <thead>
                            <tr>
                                <th>Donor Name</th>
                                <th>Contact Details</th>
                                <th>Amount</th>
                                <th>Date</th>
                                <th style={{ textAlign: "right" }}>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredList.map(x => (
                                <tr key={x.DonationId}>
                                    <td><strong>{x.Name}</strong></td>
                                    <td>
                                        <div>{x.Email}</div>
                                        <div style={{ fontSize: "0.85rem", color: "var(--text-muted)" }}>{x.Mobile}</div>
                                    </td>
                                    <td><strong style={{ color: "#16a34a" }}>${x.Amount}</strong></td>
                                    <td>{x.CreatedDate ? new Date(x.CreatedDate).toLocaleDateString() : 'N/A'}</td>
                                    <td style={{ textAlign: "right" }}>
                                        <button 
                                            className="btn btn-outline"
                                            onClick={() => handleDelete(x.DonationId)}
                                            title="Delete Donation"
                                            style={{ 
                                                color: "var(--danger)", 
                                                borderColor: "rgba(239, 68, 68, 0.2)",
                                                padding: "6px 12px"
                                            }}
                                        >
                                            Delete
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}

            {filteredList.length === 0 && !loading && (
                <div style={{ textAlign: "center", padding: "40px", color: "var(--text-muted)" }}>
                    No donations found matching your search.
                </div>
            )}

            {toast && <Toast message={toast.message} type={toast.type} onClose={() => setToast(null)} />}
        </div>
    );
}

export default DonationList;